module.exports = __webpack_public_path__ + "img/Slice6-min.3c31659f.png";